import { NgModule } from 'ng-metadata/core';
import { AccordionComponent } from './accordion.component';

/**
 * @ngdoc module
 * @name mw.components.accordion
 * @description
 *
 * Expandable/Collapsible container with header and optional footer
 */
@NgModule({
    declarations: [ AccordionComponent ]
})
export class AccordionModule {}



// WEBPACK FOOTER //
// ./src/lib/components/accordion/accordion.module.ts